import { render, staticRenderFns } from "./AiCreditsExhaustedBanner.vue?vue&type=template&id=54c48394&"
import script from "./AiCreditsExhaustedBanner.vue?vue&type=script&lang=js&"
export * from "./AiCreditsExhaustedBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports